import script from "./H5MenuCom.vue?vue&type=script&setup=true&lang=js"
export * from "./H5MenuCom.vue?vue&type=script&setup=true&lang=js"

import "./H5MenuCom.vue?vue&type=style&index=0&id=46eed18f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46eed18f"]])

export default __exports__